/* eslint-disable import/prefer-default-export */

export const BANK_LINK_DISCLAIMER_MODAL = 'BANK_LINK_DISCLAIMER_MODAL';



// WEBPACK FOOTER //
// ./src/components/BaseModal/modalTypes.js